module.exports = __webpack_public_path__ + "img/7.51b3a85f.png";